import React, { useEffect, useState } from 'react';
import { Link as RouterLink, useNavigate, useSearchParams } from 'react-router-dom';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import OutlinedInput from '@mui/material/OutlinedInput';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useForm } from 'react-hook-form';
import Logo from '../components/Logo';
import { _axios } from '../plugins/axios';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { Notify } from 'src/components/common/Notify';
import goodalipi from 'src/plugins/goodalipi';
import { services, subServices } from '../models/sideBar';
import ClevertapReact from 'clevertap-react';
import { Modal, Paper } from '@mui/material';
import * as erroConfig from '../../src/errorMessages.json'
import { sendAnalyticsEvents } from 'src/analytics/snowplow';
import { EVENT_KEYS, SNOWPLOW_EVENTS_NAME } from 'src/analytics/constants';

function Copyright() {
  console.log('login page event');
  ClevertapReact.event('login page event');
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href="https://www.medibuddy.in/">
        MediBuddy
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

function SignIn(props) {
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm({
    mode: 'onChange',
    reValidateMode: 'onChange',
    defaultValues: {
      email: '',
      password: ''
    }
  });
  const [values, setValues] = React.useState({
    showPassword: false
  });
  const [open, setOpen] = React.useState(false)
  const [password, setPassword] = React.useState()
  const [userName, setUserName] = React.useState()
  const [uuid, setUuid] = React.useState()
  const [otp, setOtp] = React.useState()
  const [counter, setCounter] = React.useState(120);
  const [email, setEmail] = React.useState();
  const [emailFlow, setEmailFlow] = React.useState(false);
  const [istimer, setIstimer] = React.useState(false);
  const [usernameFlow, setUsernameFlow] = React.useState(false);
  const [emailloginFlowClick, setEmailloginFlowClick] = React.useState(true);
  const [usernameloginFlowClick, setUsernameloginFlowClick] = React.useState(true);
  const [emailEnable, setEmailEnable] = React.useState(false);
  const [searchParams] = useSearchParams();
  const accessToken = searchParams.get('accesstoken');
  const navigate = useNavigate();

  useEffect(() => {
    const autoLoginWithToken = async () => {
      if (!accessToken) return;

      try {
        await _axios.get(
          `/authenticate/token?accesstoken=${accessToken}`
        ).then((response) => {
          if (!response.data || !response.data.isSuccess) {
            throw new Error('User Not Found');
          }

          if (!response.data.roles || !response.data.roles.length) {
            throw new Error('Access Denied');
          }

          const userData = response.data;
          const roleIds = userData.roles.map((r) => r.roleId);

          // Role-based logic 
          if (roleIds.includes(9209) || roleIds.includes(9221)) {
            goodalipi.set('isMinor', true);
          } else if (roleIds.includes(9225)) {
            goodalipi.set('isMinor', false);
          } else {
            props.snackbarShowMessage('Access Denied', 'error');
            return;
          }

          goodalipi.set('user', userData);
          if (roleIds.includes(9221)) {
            const entityIdRequested = [];
            const entityIds = userData.globalHREntityIds || {};
            Object.keys(entityIds).forEach((key) => {
              entityIdRequested.push({ key, val: entityIds[key] });
            });
            goodalipi.set('globalHRgroup', entityIdRequested);
            if (entityIdRequested.length) goodalipi.set('globalHR', true);
          }

          const url = userData.service?.[0]
            ? services[userData.service[0]].redirectUrl
            : '/app/ahc/employees';

          navigate(url, { replace: true });
        });
      } catch (err) {
        console.error('Token-based login failed', err);
        props.snackbarShowMessage('Token-based login failed, please login manually.', 'error');
        navigate('/login', { replace: true });
      }
    };

    autoLoginWithToken();
  }, []);
  
  useEffect(() => {
    if (istimer) {
      const timer =
        counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
      return () => clearInterval(timer);
    }
  }, [counter, istimer]);

  console.log('clevertap event');
  ClevertapReact.event('hrwin_login_page');
  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleClose = () => {
    setOpen(false)
    setIstimer(false)
    setCounter(120)
  }

  const submitOtp = () => {
    _axios.post('authenticate/validateOtp', {
      uuid: uuid,
      otp: otp,
      emailOTPLoginFlow: emailEnable,
      email: email
    })
      .then((response) => {
        ClevertapReact.event('user_signin_success_in_hrwin');
        sendAnalyticsEvents(SNOWPLOW_EVENTS_NAME.HRWIN_LOGGED_IN, {
          [EVENT_KEYS.EMAIL]: email
        }) 
        // response.data.service   =  [ ...response.data.service, 'AhcOnboarding'];
        const roleIds = response.data.roles
          ? response.data.roles.map((role) => role.roleId)
          : [];
        if (!roleIds.length) {
          props.snackbarShowMessage('Access Denied', 'error');
          return;
        }

        if (roleIds.indexOf(9209) > -1 || roleIds.indexOf(9221) > -1) {
          goodalipi.set('isMinor', true);
          // window.localStorage.setItem('hr_win_user',response.data)
        } else if (roleIds.indexOf(9225) > -1) {
          goodalipi.set('isMinor', false);
          // props.snackbarShowMessage('Access Denied', 'error')
        } else {
          props.snackbarShowMessage('Access Denied', 'error');
          return;
        }
        goodalipi.set('user', response.data);
        if (roleIds.indexOf(9221) > -1) {

          let entityIdRequested = [];
          let result = goodalipi.get('user');
          let entityIds = result.globalHREntityIds;
          _.keys(entityIds).forEach((each) => {
            let obj = {};
            (obj['key'] = each), (obj['val'] = entityIds[each]); P
            entityIdRequested.push(obj);
            goodalipi.set('globalHRgroup', entityIdRequested);
          });
          if (entityIdRequested.length > 0) {
            goodalipi.set('globalHR', true);
          }
        }
        console.log(response.data.service);
        const url = response.data.service[0]
          ? services[response.data.service[0]].redirectUrl
          : '/app/ahc/employees';
        navigate(url, { replace: true });
      })
      .catch(function (err) {
        alert('Invalid OTP Please try agian')
        console.log(err)
      })

  }

  const resendOtp = () => {
    _axios.post('authenticate/resenOtp', {
      uuid: uuid
    })
    setCounter(119)
  }

  const OtpVerify = (flag) => {
    return (<div>
      <Modal
        open={flag}
        // onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 400,
          bgcolor: 'background.paper',
          border: '2px solid #000',
          boxShadow: 24,
          p: 4
        }
        }>
          <Button onClick={e =>
            handleClose()
          }
            style={{
              marginLeft: "90%",
              marginTop: '-15%'
            }}>x</Button>
          <Typography id="modal-modal-title" variant="h6" component="h2"
            style={{
              textAlign: 'center',
              fontSize: 20
            }}>
            Please Enter OTP
          </Typography>
          <OutlinedInput
            // label="OTP"
            inputProps={register('otp', {
              required: 'You must provide OTP'
            })}
            autoComplete="otp"
            fullWidth
            autoFocus
            id="outlined-adornment-email"
            style={{
              marginTop: 10
            }}
            onChange={e => {
              setOtp(e.target.value)
            }}
          />

          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            sx={{ mt: 2 }}
            onClick={e => {
              submitOtp()
            }}
          >Verify</Button>
          <Box mt={3} >
            <Typography fontWeight={500} align="center" color='textSecondary'>
              OTP expires in <span style={{ color: "green", fontWeight: "bold" }}>
                {counter} Sec</span>
            </Typography></Box>
          <Typography id="modal-modal-title" variant="h6" component="h2"
            style={{
              marginTop: 20,
              textAlign: 'center',
              color: 'blue',
              fontSize: 15
            }}
            onClick={e => {
              resendOtp()
            }}>
            Resend OTP
          </Typography>
        </Box>
      </Modal>
    </div>)
  }

  const onEmailSubmit = (e) => {

    e.preventDefault()
    sendAnalyticsEvents(SNOWPLOW_EVENTS_NAME.HRWIN_LOGIN_ATTEMPTED, {
      [EVENT_KEYS.EMAIL]: email
    })
    _axios
      .post('authenticate/signin/password', {
        emailLogin: true,
        emailId: email
      })
      .then((response) => {
        if (response.data.isSuccess) {
          setEmailEnable(true);
          setOpen(true);
          setEmail(response.data.corporateEmailAddress);
          setIstimer(true)
          setUuid(response.data.uuid);
          sendAnalyticsEvents(SNOWPLOW_EVENTS_NAME.HRWIN_OTP_SCREEN, {
            [EVENT_KEYS.EMAIL]: email
          })
        } else {
          props.snackbarShowMessage(response.data.errorDescription || "looks like data not present with us", 'error');
          launchEmailFlow(false)
          launchUserNameFlow(true)
        }
      }).catch((error) => {
        setEmailFlow(false);
        setUsernameloginFlowClick(true);
        setEmailloginFlowClick(true);
        props.snackbarShowMessage(error.response && error.response.data.errorDescription || "looks like data not present with us", 'error');
      })
  }

  const onSubmit = (e) => {
    e.preventDefault()
    sendAnalyticsEvents(SNOWPLOW_EVENTS_NAME.HRWIN_LOGIN_ATTEMPTED, {
      [EVENT_KEYS.USERNAME]: userName
    })
    _axios
      .post('authenticate/signin/password', {
        username: userName,
        password: password
      })
      .then((response) => {
        //   setOpen(true)
        //    setUuid(response.data.uuid)
        //    setIstimer(true)
        // })
        // .then(function (response) {
        if (response.data.isSuccess) {
          //  response.data.subservices  = [...response.data.subservices, 'AHC - PHS Invoice']
          ClevertapReact.event('user_signin_success_in_hrwin');
          sendAnalyticsEvents(SNOWPLOW_EVENTS_NAME.HRWIN_LOGGED_IN, {
            [EVENT_KEYS.USERNAME]: userName,
          })
          const roleIds = response.data.roles
            ? response.data.roles.map((role) => role.roleId)
            : [];
          if (!roleIds.length) {
            props.snackbarShowMessage('Access Denied', 'error');
            return;
          }

          if (roleIds.indexOf(9209) > -1 || roleIds.indexOf(9221) > -1) {
            goodalipi.set('isMinor', true);
            // window.localStorage.setItem('hr_win_user',response.data)
          } else if (roleIds.indexOf(9225) > -1) {
            goodalipi.set('isMinor', false);
            // props.snackbarShowMessage('Access Denied', 'error')
          } else {
            props.snackbarShowMessage('Access Denied', 'error');
            return;
          }
          // response.data.service.push('Insurer');
          // response.data.subservices.push('Medicine - Overview');
          // response.data.subservices.push('Medicine - Track Order');
          goodalipi.set('user', response.data);
          if (roleIds.indexOf(9221) > -1) {

            let entityIdRequested = [];
            let result = goodalipi.get('user');
            let entityIds = result.globalHREntityIds;
            _.keys(entityIds).forEach((each) => {
              let obj = {};
              (obj['key'] = each), (obj['val'] = entityIds[each]);
              entityIdRequested.push(obj);
              goodalipi.set('globalHRgroup', entityIdRequested);
            });
            if (entityIdRequested.length > 0) {
              goodalipi.set('globalHR', true);
            }
          }

          const url = response.data.service[0]
            ? services[response.data.service[0]].redirectUrl
            : '/app/ahc/employees';
          navigate(url, { replace: true });
        }
        else if (response.data.isSuccess == false && response.data.checkTpAorNonTpaUserResponse && response.data.checkTpAorNonTpaUserResponse.userType == 'TPAUser') {
          props.snackbarShowMessage(erroConfig[response.data.checkTpAorNonTpaUserResponse.userType], 'error');
        }
        else if (response.data.errorMessage) {
          props.snackbarShowMessage(response.data.errorMessage, 'error');
        }
        else {
          props.snackbarShowMessage(response.data.errorDescription || "error while login", 'error')
        }
      })
      .catch(function (error) {
        let err = error && error.response && error.response.data.errorMessage ? error.response.data.errorMessage : "error while login"
        props.snackbarShowMessage(err, 'error');
      });
  };

  const launchEmailFlow = (e) => {
    setEmailFlow(e);
    setUsernameloginFlowClick(!e);
    setEmailloginFlowClick(!e);
  }

  const launchUserNameFlow = (e) => {
    setUsernameFlow(e);
    setEmailloginFlowClick(!e);
    setUsernameloginFlowClick(!e);
  }



  useEffect(() => {
    console.log('154, clever tap');
    ClevertapReact.event('login_page_event');
    hj('event', 'login_page_event');
  }, []);
  return (
    <div>
      <Grid container component="main" sx={{ height: '100vh' }}>

        <Grid
          size={{ xs: 12, sm: 4, md: 8 }}
          sx={{
            backgroundImage: 'url(/static/images/hr-wellness.png)',
            backgroundRepeat: 'no-repeat',
            backgroundColor: '#5664d2',
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
        />
        <Grid size={{ xs: 12, sm: 8, md: 4 }} component={Paper} elevation={6} square>
          <CssBaseline />
          <Box
            sx={(theme) => ({
              margin: theme.spacing(10, 4),
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center'
            })}
          >
            <Box sx={(theme) => ({ margin: theme.spacing(1) })}>
              <Logo />
            </Box>
            <Typography component="h1" variant="h5">
              HR WIN
            </Typography>
            {
              emailloginFlowClick && <Button type="submit"
                variant="contained"
                sx={{ mt: 2, mb: 2, width: '50%' }}
                color="primary" onClick={e => launchEmailFlow(true)}>
                Login via Email
              </Button>
            }
            {
              usernameloginFlowClick && <Button type="submit"
                variant="contained"
                color="primary" onClick={e => launchUserNameFlow(true)}>
                Login Via UserName/Password
              </Button>
            }
            {emailFlow && <form>
              <FormControl
                size="small"
                sx={{ mt: 1, mb: 2, width: '100%' }}
                variant="outlined"
              >
                <InputLabel htmlFor="">
                  Email
                </InputLabel>
                <OutlinedInput
                  label="email"
                  inputProps={register('email', {
                    required: 'You must provide Email'
                  })}
                  autoComplete="email"
                  error={!!errors.email}
                  fullWidth
                  autoFocus
                  id="outlined-adornment-email"
                  onChange={e => {
                    setEmail(e.target.value)
                  }}
                />
                {errors.email && (
                  <Box component="span" sx={{ color: '#bf1650', fontSize: '12px', pl: 1 }}>
                    {errors.email.message}
                  </Box>
                )}
              </FormControl>
              <Button color="inherit" onClick={e => {
                setEmailFlow(false);
                setUsernameFlow(true);
                return;
              }}>
                Login via UserName
              </Button>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                sx={(theme) => ({ mt: theme.spacing(2), mb: theme.spacing(2) })}
                onClick={e => {
                  onEmailSubmit(e);
                }}
              >
                Sign In
              </Button>
            </form>}
            {usernameFlow && <form
              style={{ width: '100%' }}
              noValidate
            // onSubmit={handleSubmit(onSubmit)}
            >
              <FormControl
                size="small"
                sx={{ mt: 1, mb: 2, width: '100%' }}
                variant="outlined"
              >
                <InputLabel htmlFor="outlined-adornment-email">
                  Username
                </InputLabel>
                <OutlinedInput
                  label="Username"
                  inputProps={register('email', {
                    required: 'You must provide Email'
                  })}
                  autoComplete="email"
                  error={!!errors.email}
                  fullWidth
                  autoFocus
                  id="outlined-adornment-email"
                  onChange={e => {
                    setUserName(e.target.value)
                  }}
                />
                {errors.email && (
                  <Box component="span" sx={{ color: '#bf1650', fontSize: '12px', pl: 1 }}>
                    {errors.email.message}
                  </Box>
                )}
              </FormControl>
              <FormControl
                size="small"
                sx={{ mt: 1, width: '100%' }}
                variant="outlined"
              >
                <InputLabel htmlFor="outlined-adornment-password">
                  Password
                </InputLabel>
                <OutlinedInput
                  label="Password"
                  type={values.showPassword ? 'text' : 'password'}
                  inputProps={register('password', {
                    required: 'You must provide Password',
                    minLength: {
                      value: 2,
                      message: 'Min length is 2'
                    }
                  })}
                  error={!!errors.password}
                  fullWidth
                  autoComplete="current-password"
                  id="outlined-adornment-password"
                  aria-describedby="outlined-weight-helper-text"
                  onChange={e => {
                    setPassword(e.target.value)
                  }}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {values.showPassword ? <Visibility /> : <VisibilityOff />}

                      </IconButton>
                    </InputAdornment>
                  }
                />
                {errors.password && (
                  <Box component="span" sx={{ color: '#bf1650', fontSize: '12px', pl: 1 }}>
                    {errors.password.message}
                  </Box>
                )}
              </FormControl>
              {/* <Grid container>
            <Grid item xs className={classes.grid}>
              <Link href="#" variant="body2">
                Forgot password?
              </Link>
            </Grid>
            <Grid item>
              <Link href="#" variant="body2">
                {"Don't have an account? Sign Up"}
              </Link>
            </Grid>
          </Grid> */}
              <Button color="inherit" onClick={e => {
                setEmailFlow(true);
                setUsernameFlow(false);
              }
              }>
                Login via Email
              </Button>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                sx={(theme) => ({ mt: theme.spacing(2), mb: theme.spacing(2) })}
                onClick={e => {
                  onSubmit(e)
                }}
              >
                Sign In
              </Button>

            </form>}
          </Box>
          <Box mt={8}>
            <Copyright />
          </Box>
        </Grid>
      </Grid>
      {OtpVerify(open)}
    </div>
  );
}
export default Notify(SignIn);
